import { AnyError, BackendException } from '@src/types/error'
import { AxiosError, isAxiosError } from 'axios'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const getErrorMessage = (error: AnyError, defaultMessage?: string) => {
  if (typeof error === 'string') return error
  if (isAxiosError(error)) {
    const axiosError = error as AxiosError
    if (typeof axiosError.response?.data === 'string') {
      return axiosError.response.data || defaultMessage
    } else if (axiosError.response?.data instanceof Object) {
      if ((axiosError.response.data as BackendException)?.message) {
        return (axiosError.response.data as BackendException)?.message
      }
      // Fallback to the default error message if no specific message is found
      // Could add more specific handling based on the structure of other error types
    }
  }
  if (error instanceof Error) return error.message
  return defaultMessage
}

export const useErrorMessage = (error: AnyError, defaultMessage?: string): string | undefined => {
  const { t } = useTranslation()
  return useMemo<string | undefined>(
    () => (error ? getErrorMessage(error, defaultMessage ?? t('common.messages.error')) : undefined),
    [defaultMessage, error, t],
  )
}
